import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

import { IconsService } from './core/icons/icons.service';
import { LANGUAGE_KEY } from '@shared/utils/constants';
import { AppState } from './store/states/app.state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private static DEFAULT_LANG = 'en';
  public readonly translateService = inject(TranslocoService);
  public readonly iconsService = inject(IconsService);
  public readonly appState = inject(AppState);

  ngOnInit(): void {
    this.iconsService.registerSvgIcons();
    this.setLanguage();
  }

  private setLanguage(): void {
    const lang = localStorage.getItem(LANGUAGE_KEY);
    this.translateService.setActiveLang(lang ?? AppComponent.DEFAULT_LANG);
  }
}
